import { IRopeTypeState, actionTypes } from 'src/ducks/rope-type.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getRopeTypeStatus = (
  state: IRopeTypeState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
